import {
    Body1Strong,
    Button,
    Caption1,
    makeStyles,
    mergeClasses,
    tokens,
} from '@fluentui/react-components'
import { ArrowSyncRegular, ErrorCircleRegular } from '@fluentui/react-icons'

import commonStyles, { useAppStyles } from '../styles/common.styles'

const useStyles = makeStyles({
  root: {
    ...commonStyles.flexRow16,
    padding: `${tokens.spacingHorizontalL} ${tokens.spacingVerticalM}`,
    backgroundColor: tokens.colorStatusDangerBackground1,
    border: `1px solid ${tokens.colorStatusDangerBorder1}`,
    borderRadius: tokens.borderRadiusXLarge,
  },
})

interface ErrorMessageBarProps {
  title?: string
  message?: string
  onRetry?: () => void
  className?: string
}

export function ErrorMessageBar({ title, message, onRetry, className }: ErrorMessageBarProps) {
  const styles = useStyles()
  const appStyles = useAppStyles()

  return (
    <div className={mergeClasses(styles.root, className && className)}>
      <ErrorCircleRegular fontSize={24} style={{ color: tokens.colorStatusDangerForeground3 }} />
      <div className={appStyles.flexColumn2}>
        <Body1Strong style={{ color: tokens.colorStatusDangerForeground2 }}>
          {title || 'An error occurred'}
        </Body1Strong>
        <Caption1 style={{ color: tokens.colorStatusDangerForeground3 }}>
          {message || 'Please try again later.'}
        </Caption1>
      </div>
      <span className={appStyles.spacer}></span>
      {onRetry && (
        <Button icon={<ArrowSyncRegular />} onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  )
}
